import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SettingsmanagerService } from '../../services/settingsmanager.service';

@Injectable()
export class TranslateInterceptor implements HttpInterceptor {
  constructor(private _settingsMngSvc: SettingsmanagerService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lang = this._settingsMngSvc.getLanguageSetting();
    if (lang) {
      // const hash = AppKeyManager.createAppKeyHash(tok);
      request = request.clone({
        setHeaders: {
          'accept-language': `${lang}`
        }
      });
    }

    return next.handle(request);
  }
}
